export default {
  pending: state => state.pending,
  pendingPagination: state => state.pendingPagination,
  requests: state => state.requests,
  requestsPagination: state => state.requestsPagination,
  currentRequest: state => state.currentRequest,
  notifications: state => state.notifications,
  unreadCount: state => state.unreadCount,
  approvalsLoading: state => state.loading
}
